import { useEffect, useState } from "react"
import { InputAdornment, TextField } from "@mui/material"

const formatNumber = (inputedValue) => { 
	if (!inputedValue || inputedValue === '0,0') return '0.00'

	let formattedNumber 	= inputedValue.toString()

	// Remove zeros à esquerda
	formattedNumber = formattedNumber.replace(/(^[^1-9]*)/g,'')

	// Remove tudo que não for números
	formattedNumber = formattedNumber.replace(/[^0-9]/g, '')

	// Separa parte inteira e parte fracionaria
	let decimalDigits = formattedNumber.substring(formattedNumber.length-2,formattedNumber.length)
	let integerDigits = formattedNumber.substring(0, formattedNumber.length-2)

	// Formata o retorno
	if (formattedNumber.length === 0) {
		return '0,00'
	} 
	else if (decimalDigits.length < 2) {
		return '0,0'+ formattedNumber
	} 
	else if (decimalDigits.length === 2 && integerDigits === '') {
		return '0,'+ formattedNumber
	}
	else if (formattedNumber.length < 6) {
		return integerDigits +','+ decimalDigits
	}
	else {
		return integerDigits.split( /(?=(?:\d{3})+(?:,|$))/g ).join( "." ) +','+ decimalDigits;
	}
}

const NumericField = (props) => {

	const {value, valueSetter, adornment, onChange, ...otherProps} 	= props
	const [currentValue, setCurrentValue]		= useState(0)

	useEffect(() => {
		setCurrentValue(formatNumber(value))
	}, [value])

	const handleInput = (event) => {
		const inputedValue = event.target.value
		// Remove tudo menos numeros e separadores
		let displayFormat	= formatNumber(inputedValue)
		let dbFormat		= displayFormat

		// Ajusta o valor para operacao em banco de dados
		if (dbFormat.match(/([0-9,]*[0-9]*\.*[0-9]{0,2})$/)) {
			dbFormat = dbFormat.replaceAll('.', '')
			dbFormat = dbFormat.replace(',', '.')
		}

		// Atualiza o valor no componente
		setCurrentValue(displayFormat)

		// Atualiza o valor do evento
		event.target.value = dbFormat

		// Sobreescreve o event nos eventos onChange/onBlur, se chamado
		if (props.onChange) props.onChange(event);
		if (props.onBlue) props.onBlur(event);
			
	}

	return (
		<TextField 
			value={currentValue}
			onChange={event => {handleInput(event)}}
			InputProps={{
				endAdornment: <InputAdornment position="start">{adornment}</InputAdornment>
			}}	
			{...otherProps}
		/>
	)
}

export default NumericField